import { render, staticRenderFns } from "./redofficial.vue?vue&type=template&id=7d26d714&"
import script from "./redofficial.vue?vue&type=script&lang=js&"
export * from "./redofficial.vue?vue&type=script&lang=js&"
import style0 from "./redofficial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports